module.exports = __webpack_public_path__ + "img/02—01—03—DynDNS > Initial State.01bee93c.jpg";